export default "__VITE_ASSET__02cd419b__"